const timelineContent = {
  change_action: 'Cambió la Acción de ',
  to: 'para',
  change_accountable: 'Se cambió el responsable de la Acción de',
  add: 'Agregó',
  text: 'como responsable de la acción',
  noAccountable: 'nadie',
  status: 'Cambió el status de',
  created: 'creó la Acción',
  deadLine: 'Cambió la fecha límite de',
  change: 'modificó la Acción',
  no_accountable: 'Sin Responsable',
  removedAccountables: 'eliminó los responsables',
  removedAccountable: 'eliminó el responsable',
  addedAccountables: 'agregó los responsables',
  addedAccountable: 'agregó el responsable',
  andAdded: 'y agregó',
};

export default timelineContent;
